<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'samplemanage-cartonTransfer',
  components: {
    PageTable,
  },
}
</script>
